<script setup>
import { useGlobalStore } from '@stores/global'
import { gsap } from 'gsap'
import { Navigation } from 'swiper/modules'
import { onMounted, ref } from 'vue'

import Button from '@components/global/button.vue'

const animatedBlock = ref(null)

const blocks = ref([
	{
		lineSrc: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/red.svg',
		image: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/home/about/item-1.jpg',
		bg: 'bg-secondary',
	},
	{
		lineSrc: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/yellow.svg',
		image: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/home/about/item-2.jpg',
		bg: 'bg-bgAccent',
	},
	{
		lineSrc: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/purple.svg',
		image: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/home/about/item-3.jpg',
		bg: 'bg-bgAccent2',
	},
	{
		lineSrc: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/red.svg',
		image: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/home/about/item-2.jpg',
		bg: 'bg-secondary',
	},
	{
		lineSrc: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/yellow.svg',
		image: 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/home/about/item-3.jpg',
		bg: 'bg-bgAccent',
	},
])

const offset = ref(window.innerWidth < 768 ? -150 : -250)

onMounted(() => {
	const animate = () => {
		gsap.to(animatedBlock.value, {
			x: offset.value * 3,
			duration: 2,
			delay: 1,
			onComplete: () => {
				gsap.to(animatedBlock.value, {
					x: offset.value * 6,
					duration: 2,
					delay: 1,
					onComplete: () => {
						gsap.to(animatedBlock.value, {
							x: 0,
							duration: 2,
							delay: 1,
							onComplete: animate,
						})
					},
				})
			},
		})
	}

	gsap.set(animatedBlock.value, { x: 0 })

	animate()
})

const global = useGlobalStore()
</script>
<template>
	<section class="container flex flex-col-reverse gap-10 lg:flex-row">
		<div class="w-full overflow-hidden lg:w-[65%]">
			<div class="flex gap-6" ref="animatedBlock">
				<div v-for="block of blocks" :class="['relative w-fit min-w-[400px] overflow-hidden rounded-2xl p-14', block.bg]">
					<img :src="block.lineSrc" class="absolute bottom-0 left-0 right-0 h-[600px] w-[600px]" alt="" />
					<img class="relative aspect-square min-w-[200px] rounded-2xl object-cover" :src="block.image" alt="" />
				</div>
			</div>
		</div>

		<div class="flex w-full flex-col gap-6 pt-5 lg:w-half lg:pt-0">
			<span class="h9">About us</span>
			<h3 class="mt-4 font-extrabold">What is a Gardener?</h3>
			<span class="text-sm text-primaryLight">A Gardener is more than just a fan of cannabis—they’re part of a community that thrives on connection, culture, and shared experiences...</span>
			<Button class="secondary mt-4 w-fit" :to="{ name: 'about' }" label="Learn about our gardeners" />
		</div>
	</section>
</template>
t
